import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  SkinOutlined,
  FullscreenOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const UniformesCadProdutosTamanhos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // TAMANHOS
  const [tamanhos, setTamanhos] = useState([]);

  // PRODUTO
  const [produto, setProduto] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (id) {
      carregarProduto(id);
      listarProdutosTamanhos(id);
    }
  }, [id]);

  useEffect(() => {
    listarTamanhos();
  }, []);

  // LISTAR FORNECEDORES
  const listarTamanhos = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_tamanhos/listar_ativos`, []);
    if (api.statusCode === 200) {
      let options_tamanhos = [];
      for (const t of api.response.data) {
        options_tamanhos.push({ value: t.id, label: t.descricao });
      }
      setTamanhos(options_tamanhos);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR PRODUTO
  const carregarProduto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setProduto(api.response.data);
    } else {
      navigate("/uniformes/gestao-produtos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarProdutosTamanhos = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos_tamanhos/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarProdutoTamanho = async (formulario) => {
    if (!formulario.id_uniformes_cad_produtos) return;
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_tamanhos/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarProdutosTamanhos(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarProdutoTamanho = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_tamanhos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarProdutosTamanhos(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarProdutosTamanhos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos_tamanhos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        especificacoes: api.response.data.especificacoes,
        codigo: api.response.data.codigo,
        id_uniformes_cad_tamanhos: api.response.data.id_uniformes_cad_tamanhos,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarProdutoTamanho = async (id_delete) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_tamanhos/deletar`, {
      id: id_delete,
    });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarProdutosTamanhos(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Código",
      dataIndex: "codigo",
      sorter: (a, b) => a.codigo?.toString()?.localeCompare(b.codigo?.toString()),
    },
    {
      title: "Especificações",
      dataIndex: "especificacoes",
      sorter: (a, b) => a.especificacoes?.localeCompare(b.especificacoes),
    },
    {
      title: "Tamanho",
      dataIndex: "tamanho",
      sorter: (a, b) => a.tamanho?.localeCompare(b.tamanho),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 90,
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarProdutosTamanhos(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarProdutoTamanho(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_uniformes_cad_produtos = id && id;
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarProdutoTamanho(formulario);
    } else {
      cadastrarProdutoTamanho(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.especificacoes?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.codigo?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.tamanho?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Tamanho
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item
                name="especificacoes"
                label="Especificações"
                rules={[{ required: true, message: "Informe as especificações!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe as especificações!"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="codigo" label="Código" rules={[{ required: true, message: "Digite o código!" }]}>
                <InputNumber
                  min={1}
                  precision={0}
                  size="large"
                  disabled={loading}
                  placeholder="Informe o código"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_uniformes_cad_tamanhos"
                label="Tamanho"
                rules={[{ required: true, message: "Selecione o tamanho!" }]}>
                <Select
                  allowClear
                  size="large"
                  placeholder="Selecione o tamanho"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={tamanhos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/gestao-produtos")} />
            <HeaderTitle
              title="Uniformes Produtos Tamanhos"
              subtitle={
                <Text italic>
                  <SkinOutlined /> {produto?.descricao ?? ""}
                </Text>
              }
              icon={<FullscreenOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
